import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import { Fetch } from "../../../../shared/Fetch";

const MonsterBranchSettingTable = (props: any) => {
  const [tableData, setTableData] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const dt = useRef<any>(null);

  const loadTableData = async () => {
    setTableLoading(true);

    const response = await Fetch("Monster_Setting/getMonsterBranchSetting", "GET", null, null, props.toast);

    if (response) {
      const data = await response.json();
      setTableData(data);
    }

    setTableLoading(false);
  };
  useEffect(() => {
    loadTableData();
  }, [props.reload]);

  return (
    <>
      <DataTable style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0" }} size="small" ref={dt} value={tableData} emptyMessage="No Data found." loading={tableLoading} showGridlines stripedRows responsiveLayout="scroll">
        <Column field="branchName" header="Branch Name" />
        <Column field="no_Of_Views" header="No of View Allowed" />
      </DataTable>
    </>
  );
};

export default MonsterBranchSettingTable;
